// extracted by mini-css-extract-plugin
export default {"timer":"oH8oCAZ6W-UA3fecf3LJ2Q=="};